import { createStore } from 'vuex';
import getters from "./getters";


const modulesFiles = require.context("./modules", true, /\.js$/);
//js自动引入当前module文件夹下的所有文件
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
    const value = modulesFiles(modulePath);
    modules[moduleName] = value.default;
    return modules;
}, {});
// 创建一个新的 store 实例
const store = createStore({
    modules, //这里是我自己理解的是为了给全局变量分组，所以需要写提前声明其他store文件，然后引入这里
    getters
});

export default store;
